const UserLogin = {

    // FIELDS
    "login": "Login",
    "email": "Email",
    "password": "Password",
    "forgot_password": "Forgot Password",
    "remember_me": "Remember Me",
    "reset_password": "Reset Password",
    "new_password": "New Password",
    "confirm_password": "Confirm Password",
    
    // PAGE HEADER
    "login_title": "Login",
    "forgot_password_title": "Forgot Password",
    "reset_password_title": "Reset Password",
    
    // ERROR
    "error_email": "Enter Email",
    "error_password": "Enter Password",
    "error_invalid_email": "Invalid Email",
    "error_new_password": "Enter New Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_password_mismatch": "Passwords do not match",
    
    // MESSAGES
    "login_success": "Login Successful",
    "login_failed": "Invalid Email or Password",
    "password_reset_success": "Password Reset Successful",
    "password_reset_failed": "Password Reset Failed",

}

export default UserLogin;

